import { render, staticRenderFns } from "./tz-breadcrumbs.vue?vue&type=template&id=52c34824"
import script from "./tz-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./tz-breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./tz-breadcrumbs.vue?vue&type=style&index=0&id=52c34824&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_lodash@4.17.21_prettier@1.19.1_vue-tem_7hv2m4comruphsqmfeqhuqwlt4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports